import React from 'react';
import { useScreenSubscription } from '../subscription/screenProviderLocationAccount';
import PaymentBase from './paymentBase';
import { WORK_FLOW_COMMON_SCREENS } from '../subscription/const';

export const PaymentDynamic = () => {
    const { goBack, navigateTo, setSelectedCard } = useScreenSubscription();
  
  const goToEditCard = (card) => {
    setSelectedCard( card )
    navigateTo(WORK_FLOW_COMMON_SCREENS.PAYMENT_METHOD_EDIT)
  };
  
  return (
    <PaymentBase
      title={'linkedPaymentMethods'} 
      goBack={goBack}
      goAddCard={() => navigateTo(WORK_FLOW_COMMON_SCREENS.ADD_PAYMENT_METHOD)}
      goToEditCard={goToEditCard}
    />
  )
}